import type { ComponentProps } from "react";

import Activation from "common/account/activation";

export default (props: Omit<ComponentProps<typeof Activation>, "redirectTo">) => (
  <Activation {...props} redirectTo="/setup" />
);
